import { Link } from 'gatsby'
import { FaUndo } from 'react-icons/fa'
import { RESULTS_EMAIL } from '../../constants'

const KitCompleted = ({ onRestart }: { onRestart: () => void }) => (
  <div>
    <h1 className="title is-spaced has-text-midnightBlue">Your Kit Has Been Completed</h1>

    <p>
      We've analysed your results and sent them to the email address that you registered with, thanks for using C19
      Testing!
    </p>

    <p className="mt-4">
      If you didn't receive your results, please check your junk/spam folder and make sure{' '}
      <a href={`mailto:${RESULTS_EMAIL}`}>{RESULTS_EMAIL}</a> is on your 'Safe Senders' list. If you still don't see the
      results email, or there's a problem with your certificate, you can{' '}
      <Link to="/contact">contact our support team</Link>.
    </p>

    <hr />

    <p className="mt-3">
      <button className="button is-text pl-0 is-size-7" onClick={onRestart}>
        <div className="is-flex is-align-items-center">
          <FaUndo className="mr-2" /> Start over with another kit ID
        </div>
      </button>
    </p>
  </div>
)

export default KitCompleted
